import React, { useState, useEffect } from "react";
import { Empty, Modal } from "antd";
import { HiPlus } from "react-icons/hi";
import { Switch } from "antd";
import {
  DropdownJobtype,
  DropdownIf,
  DropdownState,
  DropdownValue,
  DropdownDo,
} from "./dropdownIf";
import AddDropDownoption from "./addDropdownOption";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import { loaderReducer } from "../../../components/toolkit/loader";
import {
  createGenericTemplate,
  ListGenericTemplate,
  UpdateGenericTemplate,
} from "../../../functions/genericTemplate";
import { useDispatch } from "react-redux";

const toArray = (val) => (Array.isArray(val) ? val : Object.values(val || {}));

const QestionnaireTem = ({
  arg: {
    isGTEdit,
    editDataGenericTemplate,
    setIsModalOpen1,
    isModalOpen1,
    qestionnaireTemHandleOk,
    qestionnaireTemHandleCancel,
    customImageUpload1,
    setCustomImageUpload1,
    customTextField1,
    setCustomTextField1,
    customDropDown1,
    setCustomDropDown1,
    genericTemplateFetchData,
    setGenericTemplateJobTypeList,
    genericTemplateJobTypeList,
  },
}) => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  const dispatch = useDispatch();
  const [qtFormData, setQTFormData] = useState({
    title: "",
    tranId: "",
    jobType: true,
    id: "",
  });
  const [qtdropdowns, setQTDropDowns] = useState([]);
  const [ifDoQuestions, setIfDoQuestions] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedForJobType, setIsCheckedForJobType] = useState(true);

  useEffect(() => {
    if (isGTEdit === true) {
      setQTFormData(prevState => ({
        ...prevState,
        title: editDataGenericTemplate.title,
        tranId: editDataGenericTemplate.tranId,
        jobType: editDataGenericTemplate.jobType,
        id: editDataGenericTemplate._id,
      }));

      setQTDropDowns(editDataGenericTemplate.customGeneric || []);
    }
  }, [isGTEdit, editDataGenericTemplate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQTFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //-----------Generate UUID----------------------
  function generateCustomUUID() {
    let uuid = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 24; i++)
      uuid += characters.charAt(Math.floor(Math.random() * characters.length));
    return uuid;
  }

  //-----------text field added----------------------
  const addCustomTextField = () => {
    const newUuid = generateCustomUUID();
    const newUniqueid = generateCustomUUID();
    setQTDropDowns([
      ...qtdropdowns,
      {
        uuid: newUuid,
        type: "text",
        question: "",
        require_response: "false",
        make_conditional: "false",
        conditions: [
          {
            uuid: newUniqueid,
            if: "",
            state: "",
            value: "",
            do: "",
            doType: "",
            questionId: "",
          },
        ],
      },
    ]);
  };
  const removeCustomTextField = (index) => {
    const updatedCustomTextField = [...customTextField1];
    updatedCustomTextField.splice(index, 1);
    setCustomTextField1(updatedCustomTextField);
  };
  const handleSwitchCustomTextField = (index) => {
    const updatedCustomTextField = [...customTextField1];
    updatedCustomTextField[index].makeconditional =
      !updatedCustomTextField[index].makeconditional; // toggle the makeconditional property
    setCustomTextField1(updatedCustomTextField);
  };
  //------------------dropdown added-------------------

  const addCustomDropDown = () => {
    const newUuid = generateCustomUUID();
    const newUniqueid = generateCustomUUID();
    setQTDropDowns([
      ...qtdropdowns,
      {
        uuid: newUuid,
        type: "dropdown",
        sort: "",
        question: "",
        options: [""],
        require_response: "false",
        make_conditional: "false",
        conditions: [
          {
            uuid: newUniqueid,
            if: "",
            state: "",
            value: "",
            do: "",
            doType: "",
            questionId: "",
          },
        ],
      },
    ]);
  };
  //----------image upload functionality------------
  const addCustomImageUpload = () => {
    const newUuid = generateCustomUUID();
    setQTDropDowns([
      ...qtdropdowns,
      {
        uuid: newUuid,
        type: "image",
        sort: "",
        upload_image: "",
        foot_photo: "",
        geotag: "",
        include_image_upload_field: "false",
      },
    ]);
  };

  const removeCustomField = (index) => {
    const updatedDropDowns = [...qtdropdowns];
    updatedDropDowns.splice(index, 1);
    setQTDropDowns(updatedDropDowns);
  };

  const handleUploadImageChange = (index, e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    setQTDropDowns((prev) => {
      const updated = [...prev];
      const item = { ...updated[index] };
      item[name] = file;
      updated[index] = item;
      return updated;
    });
  };

  const inputHandler = (index, type, e, isChecked, isCheckedForJobType) => {
    const { name, value } = e.target;
    setQTDropDowns((prev) => {
      const updated = [...prev];
      const item = { ...updated[index] };
      item[name] = value;
      updated[index] = item;
      return updated;
    });
  };

  const handleCheckboxChange = (e, index) => {
    const isChecked = e.target.checked; // Boolean: true if checked, false if not
    setIsChecked(e.target.checked); // Set the state to the checkbox's checked value
    inputHandler(index, "geotag", e, isChecked); // Pass the boolean to the handler
  };

  const handleSwitchChange = (index, type) => {
    setQTDropDowns((prev) => {
      const updated = [...prev];
      const item = { ...updated[index] };
      item[type] = item[type] === "true" ? "false" : "true";

      if (type === "make_conditional" && item[type] === "false") {
        item["if"] = "";
        item["state"] = "";
        item["value"] = "";
        item["do"] = "";
        getQuestion();
      }
      updated[index] = item;
      return updated;
    });
  };

  const getQuestion = () => {
    qtdropdowns?.map((qtdropdown) => {
      if (qtdropdown?.question) {
        const extractedQuestions = qtdropdowns.map((item) => {
          if (item.type === "dropdown" || item.type === "text") {
            return { key: item.uuid, value: item.question };
          } else if (item.type === "image") {
            return { key: item.uuid, value: item.foot_photo };
          }
        });

        setIfDoQuestions(extractedQuestions);
      }
    });
  };

  const handleSelectChange = (index, conditionIndex, state, value) => {
    setQTDropDowns((prev) => {
      const updated = [...prev];
      const item = { ...updated[index] };
      
      let conditions = [...toArray(item.conditions)];

      const condition = { ...conditions[conditionIndex] };
      condition[state] = value;

      if (state === "do") {
        const target = prev.find(
          (dropdown) => dropdown.question === value || dropdown.foot_photo === value
        );
        if (target) {
          condition["doType"] = target.type;
          condition["questionId"] = target.uuid;
        }
      }

      conditions[conditionIndex] = condition;
      item.conditions = conditions;
      updated[index] = item;
      return updated;
    });
  };

  const inputHandlerCondition = (index, conditionIndex, type, e) => {
    const { name, value } = e.target;
    setQTDropDowns((prev) => {
      const updated = [...prev];
      const item = { ...updated[index] };
      
      let conditions = [...toArray(item.conditions)];

      const condition = { ...conditions[conditionIndex] };
      condition[name] = value;

      conditions[conditionIndex] = condition;
      item.conditions = conditions;
      updated[index] = item;
      return updated;
    });
  };

  const addNewCondition = (dropDownIndex) => {
    const newUuid = generateCustomUUID();
    setQTDropDowns((prev) => {
      const updated = [...prev];
      const item = { ...updated[dropDownIndex] };
      let conditions = toArray(item.conditions);

      item.conditions = [
        ...conditions,
        {
          uuid: newUuid,
          if: "",
          state: "",
          value: "",
          do: "",
          doType: "",
          questionId: "",
        },
      ];
      updated[dropDownIndex] = item;
      return updated;
    });
  };

  const closePopup = () => {
    setQTDropDowns([]);
    setQTFormData({
      title: "",
      tranId: "",
      jobType: "",
      id: "",
    });
    setIsModalOpen1(false);
  };
  // const removeCustomImageUpload = (index) => {
  //   const updatedCustomImageUpload = [...customImageUpload1];
  //   updatedCustomImageUpload.splice(index, 1);
  //   setCustomImageUpload1(updatedCustomImageUpload);
  // };

  // const handleSwitchChangeImageUpload = (index) => {
  //   const updatedCustomImageUpload = [...customImageUpload1];
  //   updatedCustomImageUpload[index].checked =
  //     updatedCustomImageUpload[index].checked == "true" ? false : true;
  //   setCustomImageUpload1(updatedCustomImageUpload);
  // };

  // const handleGeotagChange = (index, value) => {
  //   const updatedGeotag = [...customImageUpload1];
  //   console.log(updatedGeotag);
  //   updatedGeotag[index].geotag = value;
  //   setCustomImageUpload1(updatedGeotag);
  // };

  // const handleUploadTitleChange = (index, value) => {
  //   const updatedUploadTitle = [...customImageUpload1];
  //   updatedUploadTitle[index].upload_title = value;
  //   setCustomImageUpload1(updatedUploadTitle);
  // };

  // const handleUploadImageChange = (index, value) => {
  //   const updatedUploadImage = [...customImageUpload1];
  //   updatedUploadImage[index].upload_image = value.target.files[0];
  //   setCustomImageUpload1(updatedUploadImage);
  //   console.log(customImageUpload1);
  // };

  // const handlejobTypeSelectChange = (state, value) => {
  //   console.log("object", state, value);
  //   setQTFormData((prevState) => ({
  //     ...prevState,
  //     [state]: value,
  //   }));
  // };

  const handlejobTypeSelectChange = (state, isCheckedForJobType) => {

    setQTFormData((prevState) => ({
      ...prevState,
      [state]: isCheckedForJobType,
    }));
  };

  const handleCheckboxChangeForJobType = (e) => {
    const isCheckedForJobType = e.target.checked;

    setIsCheckedForJobType(isCheckedForJobType); // Set the state to the checkbox's checked value
    // inputHandler(index, "jobType", e, isCheckedForJobType); // Pass the boolean to the handler
    handlejobTypeSelectChange("jobType", isCheckedForJobType);
  };

  function generateCustomTranId() {
    let tranId = "";
    const characters = "0123456789";
    for (let i = 0; i < 5; i++)
      tranId += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    return tranId;
  }

  const submitFormQT = async () => {
    // Sanitize qtdropdowns to ensure conditions and options are always arrays
    const sanitizedCustomGeneric = qtdropdowns.map((item) => ({
      ...item,
      conditions: toArray(item.conditions),
      options: item.type === "dropdown" ? toArray(item.options) : item.options,
    }));

    const finalFormData = {
      ...qtFormData,
      customGeneric: sanitizedCustomGeneric,
    };

    if (!isGTEdit) {
      dispatch(loaderReducer(true));
      const newTranId = generateCustomTranId();
      await createGenericTemplate(token, finalFormData)
        .then((res) => {
          toast.success(`${res.data.message}`);
          setQTFormData({
            title: "",
            tranId: "",
            jobType: "",
            id: "",
          });
          genericTemplateFetchData();
          dispatch(loaderReducer(false));
        })
        .catch((err) => {
          dispatch(loaderReducer(false));
          toast.error(err.message);
        });
    } else {
      dispatch(loaderReducer(true));
      try {
        await UpdateGenericTemplate(qtFormData.id, token, finalFormData)
          .then((res) => {
            dispatch(loaderReducer(false));
            toast.success(`${res.data.message}`);
            setQTDropDowns([]);
            setQTFormData({
              title: "",
              tranId: "",
              jobType: "",
              id: "",
            });
            genericTemplateFetchData();
          })
          .catch((err) => {
            dispatch(loaderReducer(false));
            toast.error(`Getting error ${err}`);
          });
      } catch (error) {
        toast.error(error);
        dispatch(loaderReducer(false));
      }
    }
    setIsModalOpen1(false);
  };

  useEffect(() => {
    getQuestion();
  }, [qtdropdowns]);

  return (
    <div>
      <Modal
        title=" "
        open={isModalOpen1}
        onOk={qestionnaireTemHandleOk}
        onCancel={() =>
          qestionnaireTemHandleCancel(setQTDropDowns, setQTFormData)
        }
        width={"60%"}
        footer={null}
      >
        <div>
          <div>
            <div className="tupdate mt-3">
              {isGTEdit ? "Update" : "Create"} Questionnaire Template
            </div>
            <div className="row mt-3">
              <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                Template Title
              </div>
              <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  value={qtFormData.title}
                  onChange={(e) => handleChange(e)}
                  placeholder="New Install Closing Questionnaire"
                  required
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                Apply To All Job Type
              </div>
              <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                <input
                  type="checkbox"
                  placeholder="Type here"
                  name="jobType"
                  value={isCheckedForJobType ? true : false}
                  checked={isCheckedForJobType}
                  onChange={(e) =>
                    handleCheckboxChangeForJobType(e, isCheckedForJobType)
                  }
                />
                {/* <DropdownJobtype
                  genericTemplateJobTypeList={genericTemplateJobTypeList}
                  setGenericTemplateJobTypeList={setGenericTemplateJobTypeList}
                  jobTypeDetail={qtFormData.jobType}
                  onSelectChange={(value) =>
                    handlejobTypeSelectChange("jobType", value)
                  }
                /> */}
              </div>
            </div>
            <div className="tupdate mt-3">Add Custom Questionnaire Fields</div>

            {/* buttons */}
            <div className="d-flex gap-2 mt-2" style={{ color: "#414C60" }}>
              <div
                className="contd "
                style={{ width: "11rem" }}
                onClick={addCustomTextField}
              >
                Add Text Field
                <span>
                  <HiPlus size={20} />
                </span>
              </div>
              <div
                className="contd"
                style={{ width: "14rem" }}
                onClick={addCustomDropDown}
              >
                Add Dropdown Field
                <span>
                  <HiPlus size={20} />
                </span>
              </div>
              <div
                className="contd "
                style={{ width: "11rem" }}
                onClick={addCustomImageUpload}
              >
                Add Image Field
                <span>
                  <HiPlus size={20} />
                </span>
              </div>
            </div>
          </div>

          {qtdropdowns &&
            qtdropdowns.map((dropdown, index) => (
              <>
                {dropdown?.type && dropdown.type === "dropdown" ? (
                  <AddDropDownoption
                    arg={{
                      index,
                      qtdropdowns,
                      dropdown,
                      setQTDropDowns,
                      addCustomDropDown,
                    }}
                  />
                ) : dropdown?.type && dropdown.type === "text" ? (
                  <div key={index}>
                    <hr />
                    <div className="tupdate mt-3">
                      Custom Text Field {index + 1}
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                        Question
                      </div>
                      <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                        <input
                          type="text"
                          className="form-control"
                          name="question"
                          value={dropdown.question}
                          onChange={(e) => inputHandler(index, "question", e)}
                          placeholder="Was Product 1 installed/serviced?"
                          required
                        />
                      </div>
                      <div className="mt-3 d-flex justify-content-between">
                        <div className="sub2head mt-2">Require Response</div>
                        <Switch
                          onChange={() =>
                            handleSwitchChange(index, "require_response")
                          }
                          defaultChecked={
                            dropdown.require_response === "true" ? true : false
                          }
                        />
                      </div>
                      <div className="mt-2 d-flex justify-content-between">
                        <div className="sub2head mt-2">Make Conditional</div>
                        <Switch
                          onChange={() =>
                            handleSwitchChange(index, "make_conditional")
                          }
                          defaultChecked={
                            dropdown.make_conditional === "true" ? true : false
                          }
                        />
                      </div>
                      {/* ---------dropdown------- */}
                      {dropdown.make_conditional === "true" && (
                        <div>
                          {Object.values(dropdown.conditions).map(
                            (condition, conditionIndex) => (
                              <>
                                <div className="row mt-2">
                                  <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                                    IF
                                  </div>
                                  <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                                    <DropdownIf
                                      ifDetail={condition.if}
                                      DoValueDetail={condition.do}
                                      ifDoQuestions={ifDoQuestions}
                                      uuid={condition.uuid}
                                      onSelectChange={(value) =>
                                        handleSelectChange(
                                          index,
                                          conditionIndex,
                                          "if",
                                          value
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="row mt-2">
                                  <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                                    STATE
                                  </div>
                                  <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                                    <DropdownState
                                      stateDetail={condition.state}
                                      onSelectChange={(value) =>
                                        handleSelectChange(
                                          index,
                                          conditionIndex,
                                          "state",
                                          value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="row mt-2">
                                  <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                                    VALUE
                                  </div>
                                  <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="value"
                                      value={condition.value}
                                      onChange={(e) =>
                                        inputHandlerCondition(
                                          index,
                                          conditionIndex,
                                          "value",
                                          e
                                        )
                                      }
                                      placeholder="Enter Value"
                                      required
                                    />
                                  </div>
                                </div>
                                {/* -- */}
                                <div className="row mt-2 pb-2 border-bottom">
                                  <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                                    DO
                                  </div>
                                  <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                                    <DropdownDo
                                      doDetail={condition.do}
                                      ifValueDetail={condition.if}
                                      ifDoQuestions={ifDoQuestions}
                                      uuid={condition.uuid}
                                      onSelectChange={(value) =>
                                        handleSelectChange(
                                          index,
                                          conditionIndex,
                                          "do",
                                          value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </>
                            )
                          )}

                          <div className="d-flex justify-content-end mt-3">
                            <div
                              className="contd"
                              style={{ width: "14rem" }}
                              onClick={() => addNewCondition(index)}
                            >
                              Add Condition
                              <span>+</span>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="mt-2 d-flex justify-content-end">
                        <div
                          className="editbtn mt-2"
                          onClick={() => removeCustomField(index)}
                        >
                          Remove Custom Text Field
                        </div>
                      </div>
                    </div>
                  </div>
                ) : dropdown?.type && dropdown.type === "image" ? (
                  <div className="row mt-3" key={index}>
                    <hr />
                    <div className="tupdate ">
                      Custom Image Upload {index + 1}
                    </div>
                    <div className="row mt-3">
                      <div className="row position-relative">
                        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
                          Upload Title
                        </div>
                        <div className="col-lg-10 col-md-8 col-sm-12 d-flex gap-2 position-relative">
                          {/* <input
                            type="file"
                            accept="image/*"
                            name="upload_image"
                            onChange={(e) => handleUploadImageChange(index, e)}
                            required
                          /> */}
                          <input
                            className="form-control"
                            placeholder="8 Foot Photo"
                            name="foot_photo"
                            value={dropdown.foot_photo}
                            onChange={(e) =>
                              inputHandler(index, "foot_photo", e)
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      {/* <div className="row position-relative">
                      <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
                        Geotag (optional)
                      </div>
                      <div className="col-lg-10 col-md-8 col-sm-12 d-flex gap-2 position-relative">
                        <input
                          className="form-control"
                          placeholder="Type here"
                          name="geotag"
                          value={dropdown.geotag}
                          onChange={(e) => inputHandler(index, 'geotag', e)}
                        />
                      </div>
                    </div> */}
                      <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
                        Geotag (optional)
                      </div>
                      <div className="col-lg-10 col-md-8 col-sm-12 d-flex gap-2 position-relative">
                        <input
                          type="checkbox"
                          placeholder="Type here"
                          name="geotag"
                          value={isChecked ? false : true}
                          checked={isChecked}
                          onChange={(e) => handleCheckboxChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="mt-2 d-flex justify-content-between">
                      <div className="sub2head mt-2">
                        Include Image Upload Field
                      </div>
                      <Switch
                        onChange={() =>
                          handleSwitchChange(
                            index,
                            "include_image_upload_field"
                          )
                        }
                        defaultChecked={
                          dropdown.include_image_upload_field === "true"
                            ? true
                            : false
                        }
                      />
                    </div>
                    <div className="mt-2 d-flex justify-content-end">
                      <div
                        className="mt-2 editbtn"
                        onClick={() => removeCustomField(index)}
                      >
                        Remove Custom Image Upload
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </>
            ))}

          {/* button */}
          <div className="d-flex mt-4 gap-2 justify-content-end">
            <div className="contd" onClick={closePopup}>
              Exit without Saving
            </div>{" "}
            <div
              className="contd"
              style={{ backgroundColor: "#1C449C", color: "white" }}
              onClick={submitFormQT}
            >
              Save Changes
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default QestionnaireTem;
